import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import _ from 'lodash';
import {
  Icon,
  Label,
} from 'semantic-ui-react';
import { compose } from 'recompose';

import withPendingInvitationData from '../../hocs/data/with-pending-invitations';
import withUserInfo from '../../hocs/has-user-info';

import UserHandler from '../../containers/user-handler';
import { authService } from '../../utils/auth-service';
import { updateUser } from '../../containers/user-widget/actions';
import ThemeSelector from '../../themes/theme-selector';

import { loadingCampaignsList } from '../../containers/influencers-campaign-list/actions';

const V2_ORGS = [
];

const ELEMIS = 'df27f0a0-7ad2-4161-b14e-f928b464a85b';
const LAUNCH_METRICS = '4a6b0ee0-6c1a-423b-984f-49a7cb849d1e';
const ABBOTT_LYON = '6b7ed405-e8ef-4b8d-9515-f09108e9e367';
const ELEVEN_MEADOW = '2434ffc0-b36a-4b07-84ac-7ec04069c4c9';


const invitationNotificationIconStyle = {
  background: '#20c49e',
  color: 'white',
};

const RESTRICTED_CORQ_DOMAINS = [
  'data.corq.studio',
  'corq.dyzio.co',
];

// TODO Needs refactoring to have user widget separate that extracts user data
class Header extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    const userProfile = authService.getProfile();

    if (userProfile) {
      this.props.onUpdateUser(userProfile);
    }
    authService.on('profile_updated', newProfile => {
      this.props.onUpdateUser(newProfile);
    });

    this.state = {
      updated: false,
      pendingInvitationsCount: 0,
    };
  }

  componentDidMount = async () => {
    if (!this.props.campaignsList.size) {
      this.props.onLoadingCampaignsList();
    }
    const { getPendingInvitationsCountByEmail, userInfo: { email } } = this.props;
    const pendingInvitationsCount = await getPendingInvitationsCountByEmail(email);
    this.setState({
      pendingInvitationsCount,
    });
  }

  componentWillReceiveProps = async nextProps => {
    const { user } = nextProps;
    const { updated } = this.state;
    if (user && !updated) {
      const userProfile = authService.getProfile();
      if (userProfile) {
        this.props.onUpdateUser(userProfile, user);
        this.setState({
          updated: true,
        });
      }
    }
  }

  profileFeedback = action => {
    window.Intercom('shutdown');
    authService.logout();
    this.context.router.push(action);
  };

  render() {
    const { user, userData } = this.props;

    const { pendingInvitationsCount } = this.state;

    const profile = authService.getProfile();
    const { role, enrolledBy } = profile.app_metadata.dyzio;
    const selfEnrolled = role === 'INFLUENCER' && enrolledBy === 'SELF';
    const organisationId = userData.get('organisationId');
    const isV2Org = _.includes(V2_ORGS, organisationId);

    const theme = ThemeSelector.theme();
    const { isLightOnDark } = theme;
    const linkStyle = theme.linkStyle || {};
    const headerStyle = theme.headerStyle || {};
    const showHelpLink = !selfEnrolled && !theme.disableHelpLinks;

    const showShortlists = !theme.hideShortlists;
    const showMyInfluencers = !theme.hideMyInfluencers;
    const showHomepage = !theme.hideHomepage;
    const showCampaignsV2 = showShortlists; // overload this for convenience

    const { host } = window.location;

    const isCorq = _.includes(RESTRICTED_CORQ_DOMAINS, host);
    const isElemis = organisationId === ELEMIS;
    const isLaunchMetrics = organisationId === LAUNCH_METRICS;
    const isAbbottLyon = organisationId === ABBOTT_LYON;
    const isElevenMeadow = organisationId === ELEVEN_MEADOW;

    return (
      <div className="page-navigation-header" style={headerStyle}>
        <div className="flex-item">
          <img
            onClick={() => this.context.router.push('/')}
            className="logo"
            style={{ height: theme.headerLogo.size || 40 }}
            src={theme.headerLogo.src}
            alt={theme.headerLogo.alt}
          />
        </div>
        <div className="flex-item">
          { user && user.role !== 'INFLUENCER' && showHomepage &&
            <p><Link style={linkStyle} to="/home"><Icon name="home" />Home</Link></p>
          }
        </div>
        {isLaunchMetrics &&
        <div className="flex-item">
          <p>
            <Link style={linkStyle} to="/launch-metrics/dashboard">Dashboard</Link>
          </p>
        </div>
        }
        {isAbbottLyon &&
        <div className="flex-item">
          <p>
            <Link style={linkStyle} to="/abbott-lyon/dashboard">Dashboard</Link>
          </p>
        </div>
        }
        {isAbbottLyon &&
        <div className="flex-item">
          <p>
            <Link style={linkStyle} to="/abbott-lyon/orders">Orders</Link>
          </p>
        </div>
        }
        {isElevenMeadow &&
        <div className="flex-item">
          <p>
            <Link style={linkStyle} to="/eleven-meadow/dashboard">Dashboard</Link>
          </p>
        </div>
        }
        <div className="flex-item">
          { user && user.role !== 'INFLUENCER' && showMyInfluencers &&
            <p><Link style={linkStyle} to="/influencers">My Influencers</Link></p>
          }
        </div>
        <div className="flex-item">
          { user && user.role !== 'INFLUENCER' && showShortlists &&
            <p>
              <Link style={linkStyle} to="/shortlists">Shortlists</Link>
            </p>
          }
        </div>
        <div className="flex-item dropdown">
          <p>
            <a style={linkStyle} onClick={() => this.context.router.push('/dashboard')}>
              Campaigns
            </a>
          </p>
        </div>
        {
          isV2Org && showCampaignsV2 &&
          <div className="flex-item" >
            <p>
              <Link style={_.assign({ color: 'orange' }, linkStyle)} to="/campaigns/v2">
                Campaigns V2
                <Icon name="lab" />
              </Link>
            </p>
          </div>
        }
        <div className="flex-item">
          { user && user.role === 'INFLUENCER' && !selfEnrolled &&
            <p>
              <Link style={linkStyle} to="/influencer/authorisation">Authorisation</Link>
            </p>
          }
        </div>
        <div className="flex-item">
          { user && user.role === 'INFLUENCER' && !selfEnrolled &&
            <p>
              <Link style={linkStyle} to="/influencer/my-requests">My requests</Link>
            </p>
          }
        </div>
        {isElemis && <div className="flex-item dropdown">
          <p>
            <a style={linkStyle} onClick={() => this.context.router.push('/creators/approvals')}>
              Approvals
            </a>
          </p>
        </div>}
        {isElemis && <div className="flex-item dropdown">
          <p>
            <a style={linkStyle} onClick={() => this.context.router.push('/shopfluence/dashboard')}>
              Dashboard
            </a>
          </p>
        </div>}

        {isElemis && <div className="flex-item dropdown">
          <p>
            <a style={linkStyle} onClick={() => this.context.router.push('/skinsiders/dashboard')}>
              <em>SKINSIDERS</em>
            </a>
          </p>
        </div>}
        <div className="flex-spacer" />
        {
          showHelpLink &&
          <div className="flex-item">
            <p><a style={linkStyle} href="http://help.dyzio.co" target="_blank" rel="noopener noreferrer">Help</a></p>
          </div>
        }
        <div className="flex-item dropdown">
          <UserHandler isLightOnDark={isLightOnDark} />
        </div>
        <div className="flex-item mobile">
          <img
            src="/icons/menu-white.svg"
            alt="menu"
            className="menu"
            onClick={this.handleMenuClick}
          />
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  onUpdateUser: PropTypes.func.isRequired,
  user: PropTypes.object,
  userData: PropTypes.object,
};

Header.defaultProps = {
  user: null,
  userData: null,
};

export function mapDispatchToProps(dispatch) {
  return {
    onUpdateUser: userData => {
      dispatch(updateUser(userData));
    },
    onLoadingCampaignsList: () => dispatch(loadingCampaignsList()),
    dispatch,
  };
}

const mapStateToProps = state => ({
  campaignsList: state.campaignList.get('campaigns'),
  currentUser: state.userData.get('currentUser'),
  userData: state.userData.get('userData'),
  user: state.user.user,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withPendingInvitationData,
  withUserInfo,
)(Header);



/** WEBPACK FOOTER **
 ** ./src/components/header/index.js
 **/